module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB4001-9de26d39befe6292e0f58e0335013513.png";